import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkdown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMarkdown"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4V20H22V4H2ZM6 9H7.3483L9 10.956L10.6517 9H12V15H10.5V11.5046L9.4483 12.75H8.5517L7.5 11.5046V15H6V9ZM16.5 9H15V12.4393L14 11.4393L12.9393 12.5L15.75 15.3107L18.5607 12.5L17.5 11.4393L16.5 12.4393V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMarkdown;
